<template xmlns:v-touch="http://www.w3.org/1999/xhtml">
  <v-container :fill-height="loading" class="user-settings" fluid pt-0>
    <v-app-bar app color="black" dark fixed>
      <hb-back-button
        :fallback-params="{
          vuosi: tehtava.vuosi,
          vastuualueId: tehtava.vastuualueId,
          valintaId: tehtava.valintaId,
        }"
        fallback="tehtavat_vuosi_vastuualue_valinta"
      />

      <v-toolbar-title v-if="!loading" style="margin-left: 0"
        >{{ $tc('tehtava.title', 1) }} -
        {{ hasEditPermission || hasLightEditPermission ? tehtava.otsikko : $t('tehtava.no_rights') }}
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <div v-if="filteredTehtavat && filteredTehtavat.length > 0 && tehtava.id" style="flex: none">
        <v-tooltip bottom>
          <span v-if="prevTehtavaExists">{{ prevTehtavaExists && filteredTehtavat[tehtavaIndex - 1].otsikko }}</span>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!prevTehtavaExists"
              :small="$vuetify.breakpoint.smAndDown"
              icon
              v-bind="attrs"
              @click="() => goToTehtava(filteredTehtavat[tehtavaIndex - 1], true)"
              v-on="on"
            >
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
        <div class="d-inline-block ml-2 mr-2">{{ tehtavaIndex + 1 }} / {{ filteredTehtavat.length }}</div>
        <!-- v-tooltip of button title-->
        <v-tooltip bottom>
          <span v-if="nextTehtavaExists">{{ nextTehtavaExists && filteredTehtavat[tehtavaIndex + 1].otsikko }}</span>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="!nextTehtavaExists"
              :small="$vuetify.breakpoint.smAndDown"
              icon
              v-bind="attrs"
              @click="() => goToTehtava(filteredTehtavat[tehtavaIndex + 1], true)"
              v-on="on"
            >
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </template>
        </v-tooltip>
      </div>
    </v-app-bar>

    <hb-loading-indicator v-if="loading" align-middle fill-height></hb-loading-indicator>

    <v-fade-transition hide-on-leave>
      <v-row v-if="(!loading && hasEditPermission) || hasLightEditPermission">
        <v-col class="mt-2" cols="12" lg="6" md="10" offset-lg="0" offset-md="1" xl="4">
          <v-form ref="tehtavaForm">
            <v-card color="#191919" outlined>
              <v-card-title primary-title>
                {{ $tc('tehtava.title', 1) }}
                <v-spacer />

                <v-menu v-if="tehtava.id" bottom left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list class="pa-0">
                    <v-tooltip :disabled="canDelete" bottom color="error">
                      <span>{{ $t('tehtava.delete_tehtava_disabled_tooltip') }}</span>
                      <template #activator="{ on, attrs }">
                        <v-list-item :input-value="true" color="error" link v-bind="attrs" @click="deleteTehtava" v-on="on">
                          <v-list-item-subtitle>
                            <v-icon>mdi mdi-trash-can-outline</v-icon>
                            {{ $t('delete') }}
                          </v-list-item-subtitle>
                        </v-list-item>
                      </template>
                    </v-tooltip>
                  </v-list>
                </v-menu>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-text-field
                  v-model.number="tehtava.vuosi"
                  :disabled="saving || !hasEditPermission"
                  :label="$t('tehtava.vuosi')"
                  type="number"
                ></v-text-field>
                <v-autocomplete
                  v-model="tehtava.vastuualueId"
                  :disabled="saving || (tehtava.vastuualueId && !!tehtava.id) || !hasEditPermission"
                  :item-text="item => item.nimi"
                  :items="vastuualueet"
                  :label="$tc('vastuualue.title', 1)"
                  :rules="[$rules.required]"
                  class="required"
                  item-value="id"
                  validate-on-blur
                ></v-autocomplete>
                <v-autocomplete
                  v-model="tehtava.vastuuuserId"
                  :disabled="saving || !hasEditPermission"
                  :item-text="item => item.firstname + ' ' + item.lastname"
                  :items="usersWithVastuualue"
                  :label="$t('tehtava.vastuuuser')"
                  :rules="[$rules.required]"
                  class="required"
                  item-value="id"
                  validate-on-blur
                ></v-autocomplete>
                <v-autocomplete
                  v-model="tehtava.valintaId"
                  :disabled="saving || !hasEditPermission"
                  :item-text="item => item.otsikko"
                  :items="filteredValinnat"
                  :label="$tc('valinta.title', 1)"
                  :rules="[$rules.required]"
                  class="required"
                  item-value="id"
                  validate-on-blur
                ></v-autocomplete>
                <v-text-field
                  v-model="tehtava.otsikko"
                  :disabled="saving || !hasEditPermission"
                  :label="$t('tehtava.otsikko')"
                  :rules="[$rules.required]"
                  class="required"
                  type="text"
                  validate-on-blur
                ></v-text-field>
                <v-textarea
                  v-model="tehtava.kuvaus"
                  :disabled="saving || !hasEditPermission"
                  :label="$t('tehtava.kuvaus')"
                  auto-grow
                  rows="1"
                  type="text"
                  validate-on-blur
                ></v-textarea>

                <date-field
                  v-model="tehtava.aloituspvm"
                  :disabled="saving || !hasEditPermission"
                  :label="$t('tehtava.aloituspvm')"
                  :rules="[$rules.required]"
                  classes="required"
                />
                <date-field
                  v-model="tehtava.maarapvm"
                  :disabled="saving || !hasEditPermission"
                  :label="$t('tehtava.maarapvm')"
                  :rules="[$rules.required]"
                  classes="required"
                />
                <v-autocomplete
                  v-model="tehtava.tila"
                  :clearable="false"
                  :disabled="saving || (!hasEditPermission && !hasLightEditPermission)"
                  :item-text="item => item.label"
                  :items="tilat"
                  :label="$tc('tehtava.tila', 1)"
                  :rules="[$rules.required]"
                  class="required"
                  validate-on-blur
                ></v-autocomplete>
              </v-card-text>
              <v-divider />
              <v-card-text>
                <v-text-field
                  v-model.number="tehtava.laajuus"
                  :disabled="saving || !hasEditPermission"
                  :label="$t('tehtava.laajuus')"
                  :rules="[v => (v <= 10 && v >= 0) || $t('tehtava.pitaa_olla_valissa', [0, 10])]"
                  type="number"
                  validate-on-blur
                ></v-text-field>
                <v-text-field
                  v-model.number="tehtava.merkitys"
                  :disabled="saving || !hasEditPermission"
                  :label="$t('tehtava.merkitys')"
                  :rules="[v => (v <= 10 && v >= 0) || $t('tehtava.pitaa_olla_valissa', [0, 10])]"
                  type="number"
                  validate-on-blur
                ></v-text-field>
                <v-text-field
                  v-model.number="tehtava.painotus"
                  :disabled="true"
                  :label="$t('tehtava.painotus')"
                  type="number"
                  validate-on-blur
                ></v-text-field>
              </v-card-text>
              <v-divider />
              <v-card-text>
                <v-text-field
                  v-model.number="tehtava.valmiusProsentti"
                  :disabled="saving || (!hasEditPermission && !hasLightEditPermission)"
                  :label="$t('tehtava.valmius_prosentti')"
                  :rules="[v => (v <= 100 && v >= 0) || $t('tehtava.pitaa_olla_valissa', [0, 100])]"
                  type="number"
                  validate-on-blur
                />
                <v-text-field
                  v-model.number="tehtava.valmiusPisteet"
                  :disabled="true"
                  :label="$t('tehtava.valmius_pisteet')"
                  type="number"
                  validate-on-blur
                />
              </v-card-text>
              <v-divider />
              <v-card-text>
                <v-text-field
                  v-model.number="tehtava.jarjestysnumero"
                  :disabled="saving || !hasEditPermission"
                  :label="$t('tehtava.jarjestysnumero')"
                  class="mt-2"
                  type="number"
                  validate-on-blur
                />
              </v-card-text>

              <v-divider />

              <v-card-actions>
                <v-spacer />
                <v-btn
                  v-if="hasEditPermission || hasLightEditPermission"
                  :block="$vuetify.breakpoint.smAndDown"
                  color="primary"
                  @click="save"
                >
                  {{ $t('save') }}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-col>

        <v-col v-if="tehtava.id" class="mt-2" cols="12" lg="6" md="10" offset-lg="0" offset-md="1" xl="4">
          <kommentit v-if="$vuetify.breakpoint.lgAndDown" :tehtava-id="tehtava.id" />
          <v-card :class="$vuetify.breakpoint.lgAndDown ? 'mt-3' : ''" :loading="loadingLiittyvatTehtavat" color="#191919">
            <v-card-title class="subtitle-1 font-weight-bold" style="color: rgba(255, 255, 255, 0.7)">
              {{ $tc('tehtava.liittyy_tehtavaan', linkit.length) }}

              <template v-if="$vuetify.breakpoint.smAndUp">
                <v-btn v-if="hasEditPermission" class="ml-3" color="primary" small @click="addLinkki('tehtava')">
                  <v-icon left>mdi mdi-plus</v-icon>
                  {{ $t('tehtava.lisaa_tehtava_linkki') }}
                </v-btn>
              </template>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-list :class="linkit.length === 0 ? 'pa-0' : ''" color="transparent">
                <v-list-item v-if="linkit.length === 0" class="ma-0 pa-0">
                  <v-alert class="mb-0" outlined text type="info" width="100%">{{ $t('tehtava.ei_liittyvia_tehtavia') }} </v-alert>
                </v-list-item>
                <v-list-item v-for="tehtava in linkit" :key="tehtava.id" color="" @click="goToTehtava(tehtava)">
                  <v-list-item-content>
                    {{ tehtava.otsikko }} - {{ tehtava.valinta && tehtava.valinta.otsikko }} -
                    {{ tehtava.valinta && tehtava.valinta.vuosi }}
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn v-if="hasEditPermission" :loading="tehtava._deleting" icon @click.stop="deleteTehtavaLinkki(tehtava)">
                      <v-icon color="error">mdi mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
            <template v-if="$vuetify.breakpoint.xsOnly">
              <v-divider />
              <v-card-actions class="px-4">
                <v-btn v-if="hasEditPermission" block color="primary" large @click="addLinkki('tehtava')">
                  <v-icon left>mdi mdi-plus</v-icon>
                  {{ $t('tehtava.lisaa_tehtava_linkki') }}
                </v-btn>
              </v-card-actions>
            </template>
          </v-card>
          <v-card class="mt-3" color="#191919">
            <v-card-title class="subtitle-1 font-weight-bold" style="color: rgba(255, 255, 255, 0.7)">
              {{ $tc('tehtava.henkilo', henkiloLinkit.length) }}
              <template v-if="$vuetify.breakpoint.smAndUp">
                <v-btn v-if="hasEditPermission" class="ml-3" color="primary" small @click="addLinkki('henkilo')">
                  <v-icon left>mdi mdi-plus</v-icon>
                  {{ $t('tehtava.lisaa_henkilo_linkki') }}
                </v-btn>
              </template>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-list :class="henkiloLinkit.length === 0 ? 'pa-0' : ''" color="transparent">
                <v-list-item v-if="henkiloLinkit.length === 0" class="ma-0 pa-0">
                  <v-alert class="mb-0" outlined text type="info" width="100%">{{ $t('tehtava.ei_liittyvia_henkiloita') }} </v-alert>
                </v-list-item>
                <v-list-item v-for="henkilo in henkiloLinkit" :key="henkilo.id">
                  <v-list-item-content>
                    {{ henkilo.firstname }}
                    {{ henkilo.lastname }}
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn v-if="hasEditPermission" :loading="henkilo._deleting" icon @click.stop="deleteHenkiloLinkki(henkilo)">
                      <v-icon color="error">mdi mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>
            <!-- <v-divider/>
          <v-card-text>
          <v-col cols="12" lg="6" md="6">
                <v-autocomplete v-model="henkiloLink.userId"
                                :item-text="(item) => item.firstname + ' ' + item.lastname"
                                :items="linkUsers"
                                :label="$tc('tehtava.henkilo',1)"
                                item-value="id"
                                validate-on-blur></v-autocomplete>
              </v-col>
            </v-card-text>-->
            <template v-if="$vuetify.breakpoint.xsOnly">
              <v-divider />
              <v-card-actions class="px-4">
                <v-btn v-if="hasEditPermission" block color="primary" large @click="addLinkki('henkilo')">
                  <v-icon left>mdi mdi-plus</v-icon>
                  {{ $t('tehtava.lisaa_henkilo_linkki') }}
                </v-btn>
              </v-card-actions>
            </template>
          </v-card>

          <v-card class="mt-3" color="#191919">
            <v-card-title class="subtitle-1 font-weight-bold" style="color: rgba(255, 255, 255, 0.7)">
              {{ $tc('tehtava.url', henkiloLinkit.length) }}
              <template v-if="$vuetify.breakpoint.smAndUp">
                <v-btn
                  v-if="$vuetify.breakpoint.smAndUp && (hasEditPermission || hasLightEditPermission)"
                  class="ml-3"
                  color="primary"
                  small
                  @click="addLinkki('url')"
                >
                  <v-icon left>mdi mdi-plus </v-icon>
                  {{ $t('tehtava.lisaa_url_linkki') }}
                </v-btn>
              </template>
            </v-card-title>
            <v-divider />
            <v-card-text>
              <v-list :class="tehtavaUlkopuolinenLinkit.length === 0 ? 'pa-0' : ''" color="transparent">
                <v-list-item v-if="tehtavaUlkopuolinenLinkit.length === 0" class="ma-0 pa-0">
                  <v-alert class="mb-0" outlined text type="info" width="100%">
                    {{ $t('tehtava.ei_liittyvia_url_linkkeja') }}
                  </v-alert>
                </v-list-item>
                <v-list-item v-for="(linkki, index) in tehtavaUlkopuolinenLinkit" :key="linkki.id" @click.stop="goToURL(linkki.url)">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ linkki.otsikko }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ linkki.url }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      v-if="hasEditPermission || hasLightEditPermission"
                      :loading="linkki._deleting"
                      icon
                      @click.stop="deleteUrlLinkki(index)"
                    >
                      <v-icon color="error">mdi mdi-delete</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card-text>

            <template v-if="$vuetify.breakpoint.xsOnly">
              <v-divider />
              <v-card-actions class="px-4">
                <v-btn v-if="hasEditPermission || hasLightEditPermission" block color="primary" large @click="addLinkki('url')">
                  <v-icon left>mdi mdi-plus </v-icon>
                  {{ $t('tehtava.lisaa_url_linkki') }}
                </v-btn>
              </v-card-actions>
            </template>
          </v-card>
        </v-col>

        <v-col v-if="tehtava.id && $vuetify.breakpoint.xlOnly" class="mt-2" cols="12" lg="6" md="10" offset-lg="0" offset-md="1" xl="4">
          <kommentit ref="kommentit" :tehtava-id="tehtava.id" view="tehtava" @add-kommentti="addLinkki('kommentti')" />
        </v-col>
      </v-row>
    </v-fade-transition>
    <v-row v-if="!loading && !hasEditPermission && !hasLightEditPermission">
      <v-col class="mt-5" cols="auto">
        <h3>{{ $t('tehtava.no_rights') }}</h3>
      </v-col>
    </v-row>
    <add-linkki-dialog
      ref="AddLinkkiDialog"
      :linkTehtavat="linkTehtavat"
      :linkUsers="linkUsers"
      :tehtava="tehtava"
      :tehtava-id="tehtava.id"
      @reload="reloadLinkItems"
      @vastuualue-selected="setVastuualueId"
      @vuosi-selected="setVuosi"
    />
  </v-container>
</template>

<script>
import api from '../apicollection';
import Kommentit from '@/components/Kommentit';
import DateField from '@/components/DateField';
import dayjs from 'dayjs';
import AddLinkkiDialog from '../components/Tehtava/AddLinkkiDialog';
import { cloneDeep, isEqual } from 'lodash';

export default {
  name: 'TehtavaEditView',
  components: { AddLinkkiDialog, DateField, Kommentit },
  data() {
    return {
      loading: true,
      loadingLinkkiTehtavat: false,
      loadingLiittyvatTehtavat: false,
      loadingLiittyvatHenkilot: false,
      loadingDelete: false,
      savingLink: false,
      savingHenkiloLink: false,
      tehtavatyypit: [],
      vastuualueet: [],

      originalTehtava: null,
      tehtava: {
        tila: 'Aloittamatta',
        vastuualueId: null,
        valintaId: null,
        vuosi: null,
        aloituspvm: null,
        maarapvm: null,
        laajuus: 5,
        merkitys: 5,
        valmiusProsentti: 0,
      },
      tehtavaUlkopuolinenLinkit: [],
      linkit: [],
      henkiloLinkit: [],
      urlLinkit: [],
      henkilot: [],
      users: [],
      valinnat: [],
      saving: false,
      showEditDialog: false,
      link: {
        vuosi: null,
        vastuualueId: null,
        tehtavaId: null,
        _tehtavat: [],
      },
      henkiloLink: {
        userId: null,
      },
      tilat: [
        {
          label: this.$t('tehtava.tilat.aloittamatta'),
          value: 'Aloittamatta',
        },
        {
          label: this.$t('tehtava.tilat.kaynnissa'),
          value: 'Kaynnissa',
        },
        {
          label: this.$t('tehtava.tilat.valmis'),
          value: 'Valmis',
        },
      ],
      headers: [
        {
          text: this.$t('tehtava.otsikko'),
          value: 'otsikko',
        },
        {
          text: this.$t('tehtava.vuosi'),
          value: 'vuosi',
        },
        {
          text: this.$tc('vastuualue.title', 1),
          value: 'vastuualue',
        },
        {
          text: this.$tc('tehtavatyyppi.title', 1),
          value: 'tehtavatyyppi',
        },
        {
          text: this.$t('tehtava.jarjestysnumero'),
          value: 'jarjestysnumero',
        },
        {
          text: '',
          value: '_',
        },
      ],
    };
  },
  computed: {
    nextTehtavaExists() {
      return this.tehtavaIndex < this.filteredTehtavat.length - 1;
    },
    prevTehtavaExists() {
      return this.tehtavaIndex > 0;
    },
    tehtavaIndex() {
      return this.filteredTehtavat.findIndex(t => t.id === this.tehtava.id);
    },
    filteredTehtavat() {
      return this.$store.state.filteredTehtavat;
    },
    canDelete() {
      return (
        this.tehtavaUlkopuolinenLinkit.length === 0 && this.henkiloLinkit.length === 0 && this.linkit.length === 0 && this.tehtava.id > 0
      );
    },
    valinta() {
      return this.valinnat.find(v => v.id === this.tehtava.valintaId);
    },
    linkTehtavat() {
      const linkitIds = this.linkit.map(tehtava => tehtava.id); // linkit on lista tehtävistä jotka linkittyy tälle tehtävälle
      return this.link?._tehtavat
        ?.filter(tehtava => {
          return !linkitIds.includes(tehtava.id); // Palautetaan tehtävö ellei sen id löydy yllä tehdyltä listalta
        })
        .sort((a, b) => a.otsikko.localeCompare(b.otsikko));
    },
    linkUsers() {
      const linkitIds = this.henkiloLinkit.map(user => user.id);
      return this.users?.filter(user => {
        return !linkitIds.includes(user.id);
      });
    },
    filteredValinnat() {
      if (!this.valinnat) return null;
      if (!this.tehtava.vastuualueId) {
        return [];
      }
      return this.valinnat.filter(v => v.vastuualueId === this.tehtava.vastuualueId && v.vuosi === this.tehtava.vuosi);
    },
    hasEditPermission() {
      return (
        !this.tehtava.id ||
        (this.tehtava.id && (this.$hasEditPermission(this.tehtava.vastuualueId) || this.tehtava.vastuuuserId === this.$user.id))
      );
    },
    hasLightEditPermission() {
      //10.2.2025 Anne: käyttäjä, joka on ainoastaan tehtävän liitetyissä henkilöissä, voi muokata: kommentteja, urleja, statusta ja prosenttia
      //7.4.2025 Juuso: lisätty uusi GuestPermission kutsu jotta vieraana vastuualueella olevalla on oikeus tehdä rajattuja muutoksia
      return (
        !this.tehtava.id ||
        (this.tehtava.id && this.henkiloLinkit?.some(l => l.id === this.$user.id)) ||
        (this.tehtava.id && (this.$hasGuestPermission(this.tehtava.vastuualueId) || this.tehtava.vastuuuserId === this.$user.id))
      );
    },
    usersWithVastuualue() {
      return this.users.filter(
        u =>
          u.id === this.tehtava.vastuuuserId ||
          u.vastuualueLinkit.some(v => v?.vastuualueId === this.tehtava.vastuualueId && v.deleted !== true)
      );
    },
  },
  methods: {
    goToURL(url) {
      if (url.includes('//')) {
        window.open(url, '_blank');
      } else {
        window.open(`//${url}`, '_blank');
      }
    },
    async reloadLinkItems(item) {
      if (item === 'tehtava') {
        await this.getLiittyvatTehtavat();
      } else if (item === 'henkilo') {
        await this.getLiittyvatHenkilot();
      } else if (item === 'url') {
        await this.getUlkopuolinenLinkit();
      }
    },
    async deleteTehtava() {
      if (this.canDelete) {
        if (!(await this.$confirmDelete(this.$t('tehtava.delete_tehtava')))) return false;
        this.loading = true;
        try {
          await api.deleteTehtava(this.tehtava);
          this.$router.go(-1);
        } catch (e) {
          console.error(e);
          this.$showErrorNotification(this.$t('errors.error_deleting_tehtava'));
        }
        this.loading = false;
      } else {
        this.$showErrorNotification(this.$t('tehtava.delete_tehtava_disabled_tooltip'), false);
      }
    },
    setVastuualueId(id) {
      this.link.vastuualueId = id;
    },
    setVuosi(vuosi) {
      this.link.vuosi = vuosi;
    },
    addLinkki(item) {
      this.$refs.AddLinkkiDialog.open(item, true);
    },
    editLinkki(item) {
      this.$refs.AddLinkkiDialog.open(item, false);
    },
    async addTehtavaLinkki() {
      if (!this.tehtava.id || !this.link.tehtavaId) return this.$showErrorNotification(this.$t('errors.error_saving_tehtava_linkki'));

      this.savingLink = true;
      try {
        await api.addTehtavaLinkki(this.tehtava.id, this.link.tehtavaId);

        this.$showSuccessNotification(this.$t('tehtava.linkki_saved'), false);
        await this.getLiittyvatTehtavat();
        this.link.tehtavaId = null;
      } catch (e) {
        console.error(e);
        this.$showErrorNotification(this.$t('errors.error_saving_tehtava_linkki'));
      } finally {
        this.savingLink = false;
      }
    },
    async deleteTehtavaLinkki(tehtava) {
      await this.$root
        .$confirm(this.$t('tehtava.delete_dialog.title'), this.$t('tehtava.delete_dialog.description'), {
          color: 'error',
          agree: this.$t('tehtava.delete_dialog.agree'),
        })
        .then(async confirm => {
          if (confirm) {
            const idx = this.linkit.findIndex(t => t.id === tehtava.id);
            this.$set(this.linkit, idx, { ...tehtava, _deleting: true });
            try {
              await api.deleteTehtavaLinkki(this.tehtava.id, tehtava.id);
            } catch (e) {
              console.error(e);
              this.$set(this.linkit, idx, { ...tehtava, _deleting: false });
              this.$showErrorNotification(this.$t('errors.error_deleting_tehtava_linkki'));
            }
            await this.getLiittyvatTehtavat();
          }
        });
    },
    async deleteUrlLinkki(index) {
      const confirm = await this.$root.$confirm(this.$t('url.delete_dialog.title'), this.$t('url.delete_dialog.description'), {
        color: 'error',
        agree: this.$t('url.delete_dialog.agree'),
      });
      if (confirm) {
        this.tehtavaUlkopuolinenLinkit[index]._deleting = true;
        try {
          await api.deleteUlkopuolinenLinkki(this.tehtava.id, this.tehtavaUlkopuolinenLinkit[index].id);
          this.$showSuccessNotification(this.$t('tehtava.url_link_deleted'), false);
        } catch (e) {
          this.$showErrorNotification(this.$t('tehtava.error_in_url_link_deleting'), false);
        } finally {
          this.tehtavaUlkopuolinenLinkit[index]._deleting = false;
          this.reloadLinkItems('url');
        }
        await this.getTehtava(this.$route.params.tehtavaId);
      }
    },
    async deleteHenkiloLinkki(henkilo) {
      const confirm = await this.$root.$confirm(this.$t('henkilo.delete_dialog.title'), this.$t('henkilo.delete_dialog.description'), {
        color: 'error',
        agree: this.$t('henkilo.delete_dialog.agree'),
      });
      if (confirm) {
        const idx = this.henkiloLinkit.findIndex(h => h.id === henkilo.id);
        this.$set(this.henkiloLinkit, idx, { ...henkilo, _deleting: true });
        try {
          await api.deleteTehtavaHenkiloLinkki(this.tehtava.id, henkilo.id);
        } catch (e) {
          console.error(e);
          this.$set(this.henkiloLinkit, idx, { ...henkilo, _deleting: false });
          this.$showErrorNotification(this.$t('errors.error_deleting_tehtava_henkilo_linkki'));
        }
        await this.getLiittyvatHenkilot();
      }
    },
    async getLiittyvatTehtavat() {
      if (!this.tehtava.id) return;
      this.loadingLiittyvatTehtavat = true;
      try {
        const linkit = await api.getTehtavaLinkit(this.tehtava.id);
        this.linkit = linkit;
      } catch (e) {
      } finally {
        this.loadingLiittyvatTehtavat = false;
      }
    },
    async addTehtavaHenkiloLinkki() {
      if (!this.tehtava.id || !this.henkiloLink.userId)
        return this.$showErrorNotification(this.$t('errors.error_saving_tehtava_henkilo_linkki'));

      this.savingHenkiloLink = true;
      try {
        await api.addTehtavaHenkiloLinkki(this.tehtava.id, this.henkiloLink.userId);

        this.$showSuccessNotification(this.$t('tehtava.henkilo_linkki_saved'), false);
        await this.getLiittyvatHenkilot();
        this.henkiloLink.userId = null;
      } catch (e) {
        console.error(e);
        this.$showErrorNotification(this.$t('errors.error_saving_tehtava_henkilo_linkki'));
      } finally {
        this.savingHenkiloLink = false;
      }
    },
    async getLiittyvatHenkilot() {
      if (!this.tehtava.id) return;
      this.loadingLiittyvatHenkilot = true;
      try {
        const linkit = await api.getTehtavaHenkiloLinkit(this.tehtava.id);
        this.henkiloLinkit = linkit;
      } catch (e) {
      } finally {
        this.loadingLiittyvatHenkilot = false;
      }
    },
    async getTehtava(id) {
      if (!id) return;

      const tehtava = await api.getTehtava(id);
      tehtava.vuosi = tehtava.valinta?.vuosi ?? null;
      this.link.year = tehtava.vuosi;

      this.originalTehtava = cloneDeep({ ...tehtava });
      this.tehtava = tehtava;
    },
    async getVastuualueet() {
      const vastuualueet = await api.getVastuualueet();
      this.vastuualueet = vastuualueet;
    },
    async getUsers() {
      const users = await api.getUsers();
      this.users = users;
    },
    async getValinnat() {
      const valinnat = await api.getValinnat();
      this.valinnat = valinnat;
    },
    async getUlkopuolinenLinkit() {
      if (this.tehtava.id) {
        const linkit = await api.getUlkopuolinenLinkit(this.tehtava.id);
        this.tehtavaUlkopuolinenLinkit = linkit;
      }
    },
    async save() {
      const tehtava = { ...this.tehtava };
      if (!this.$refs.tehtavaForm.validate()) return;
      this.saving = true;
      try {
        let tallennettuTehtava;
        if (tehtava.id) {
          tallennettuTehtava = await api.updateTehtava(tehtava);
          this.getTehtava(tallennettuTehtava.id);
        } else {
          tallennettuTehtava = await api.createTehtava(tehtava);
          this.tehtava = tallennettuTehtava;
          this.originalTehtava = cloneDeep({ ...tallennettuTehtava });
          this.$store.commit('tehtavat/SET_FILTERED_TEHTAVAT', []);
          this.$router.replace({ name: 'tehtava_muokkaus', params: { tehtavaId: tallennettuTehtava.id } });
        }
        this.$showSuccessNotification(this.$t('tehtava.saved'), false);
      } catch (e) {
        this.$showErrorNotification(this.$t('errors.error_saving_tehtava'));
      } finally {
        this.saving = false;
      }
    },
    async goToTehtava(tehtava, replace = false) {
      if (!(await this.isFormSavedConfirm())) return;
      if (replace) {
        this.$router.replace({ name: 'tehtava_muokkaus', params: { tehtavaId: tehtava.id } });
      } else {
        this.$router.push({ name: 'tehtava_muokkaus', params: { tehtavaId: tehtava.id } });
      }
    },
    async reloadAll() {
      this.loading = true;
      await this.$vuetify.goTo(0, {
        duration: 0,
        offset: 0,
      });
      await Promise.all([this.getTehtava(this.$route.params.tehtavaId)]);
      await Promise.all([this.getVastuualueet(), this.getUsers()]);
      await Promise.all([this.getValinnat()]);
      await Promise.all([this.getLiittyvatTehtavat(), this.getLiittyvatHenkilot(), this.getUlkopuolinenLinkit()]);
      this.loading = false;
    },
    async reloadLinkkiTehtavat() {
      if (this.link.vastuualueId && this.link.vuosi) {
        this.loadingLinkkiTehtavat = true;
        const tehtavat = await api.getTehtavat(this.link.vastuualueId, null, this.link.vuosi);
        this.link._tehtavat = tehtavat;
        this.loadingLinkkiTehtavat = false;
      }
    },
    calculateValmiusPisteet() {
      this.tehtava.painotus = this.$round((this.tehtava.laajuus || 0) * (this.tehtava.merkitys || 0));
      this.tehtava.valmiusPisteet = this.$round(this.tehtava.painotus * (this.tehtava.valmiusProsentti / 100) || 0);
    },
    async isFormSavedConfirm() {
      if (!this.hasEditPermission || !this.hasLightEditPermission) return true;
      if (isEqual(this.originalTehtava, this.tehtava)) {
        return true;
      }
      return await this.$root.$confirm(this.$t('tehtava.confirm_leave_without_saving'), this.$t('tehtava.you_have_unsaved_changes'));
    },
  },
  watch: {
    ['$route.params.tehtavaId']() {
      this.reloadAll();
    },
    ['link.vuosi']() {
      this.reloadLinkkiTehtavat();
    },
    ['tehtava.vuosi']() {
      if (this.tehtava.valintaId && this.valinta && this.tehtava?.vuosi !== this.valinta?.vuosi) {
        this.tehtava.valintaId = null;
        this.tehtava.valinta = null;
      }
    },
    ['tehtava.valintaId']() {
      if (this.valinta) {
        this.tehtava.vuosi = this.valinta.vuosi;
      }
    },

    ['link.vastuualueId']() {
      this.reloadLinkkiTehtavat();
    },
    ['tehtava.laajuus']() {
      this.calculateValmiusPisteet();
    },
    ['tehtava.merkitys']() {
      this.calculateValmiusPisteet();
    },
    /*['tehtava.painotus']() {
      this.calculateValmiusPisteet();
    },*/
    ['tehtava.valmiusProsentti']() {
      this.calculateValmiusPisteet();
    },
  },
  async mounted() {
    await this.reloadAll();
    if (!this.$route.params.id) {
      if (this.$route.query.vuosi) {
        this.tehtava.vuosi = parseInt(this.$route.query.vuosi);
        if (this.tehtava.vuosi) {
          this.tehtava.aloituspvm = dayjs(`${this.tehtava.vuosi}-06-01 12:00:00`, 'YYYY-MM-DD HH:mm:ss')
            .startOf('year')
            .startOf('day')
            .format('YYYY-MM-DD');
          this.tehtava.maarapvm = dayjs(`${this.tehtava.vuosi}-06-01 12:00:00`, 'YYYY-MM-DD HH:mm:ss')
            .endOf('year')
            .startOf('day')
            .format('YYYY-MM-DD');
        }
      }
      if (this.$route.query.vastuualueId) {
        this.tehtava.vastuualueId = parseInt(this.$route.query.vastuualueId);
      }
      if (this.$route.query.valintaId) {
        this.tehtava.valintaId = parseInt(this.$route.query.valintaId);
      }
      if (this.tehtava.laajuus && this.tehtava.merkitys) {
        this.calculateValmiusPisteet();
      }
    }
    this.link.vuosi = this.tehtava.vuosi;
    this.loading = false;
  },
  created() {
    window.addEventListener('beforeunload', this.isFormSavedConfirm);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.isFormSavedConfirm);
  },
  async beforeRouteLeave(to, from, next) {
    // If the form is dirty and the user did not confirm leave,
    // prevent losing unsaved changes by canceling navigation
    if (await this.isFormSavedConfirm()) {
      next();
    } else {
      // Navigate to next view
      next(false);
    }
  },
};
</script>

<style lang="scss"></style>
